import React from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {resolveInitialLocale} from 'i18n/locales'
import {AllRoutes} from './routes'
import {PromoPackageLanding} from 'attendee/PromoPackageLanding'

function RootLangRedirect() {
  const lang = resolveInitialLocale()
  return <Navigate to={`/${lang}/`} replace />
}

export function AppTopRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootLangRedirect />} />
      <Route path="/promo-packages/:slug" element={<PromoPackageLanding />} />
      <Route path="*" element={<AllRoutes />} />
    </Routes>
  )
}
